"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFirstWord = void 0;
/**
 * Takes a sentence, returns its first word.
 */
const getFirstWord = (sentence) => { var _a; return (_a = sentence.split(' ').shift()) !== null && _a !== void 0 ? _a : ''; };
exports.getFirstWord = getFirstWord;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZ2V0LWZpcnN0LXdvcmQuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvdXRpbHMvZ2V0LWZpcnN0LXdvcmQudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBQUE7O0dBRUc7QUFDSSxNQUFNLFlBQVksR0FBRyxDQUFDLFFBQWdCLEVBQUUsRUFBRSxXQUMvQyxPQUFBLE1BQUEsUUFBUSxDQUFDLEtBQUssQ0FBQyxHQUFHLENBQUMsQ0FBQyxLQUFLLEVBQUUsbUNBQUksRUFBRSxDQUFBLEVBQUEsQ0FBQztBQUR2QixRQUFBLFlBQVksZ0JBQ1cifQ==